import { Enumeration } from './Enumeration';
import Messages from '../Localization/Messages';

export const ErrorMessages = new Enumeration({
  404: {
    title: Messages.salesIdNotFound,
    description: Messages.salesIdNotFoundDescription,
  },
});
